<proffeo-ui-dialog [title]="data.titleKey | translate">
  <div class="flex flex-col w-full h-full gap-2">
    @if (users().length) {
      <proffeo-select-user-list
        [(selectedUser)]="selectedUserId"
        [originalUsers]="users()"
        [preselectedUserId]="data.preselectedUserId"
      />
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      matDialogClose
      text="close"
    />
    <proffeo-ui-button
      (clicked)="save()"
      variant="accent"
      text="save-and-close"
    />
  </div>
</proffeo-ui-dialog>
